import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';

const propTypes = {
  bsSize: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

const defaultProps = {
  bsSize: 'lg',
  value: 'placeholder',
  onChange: undefined,
};

const InputState = ({ bsSize, value, onChange }) => (
  <Input type="select" bsSize={bsSize} value={value} onChange={onChange}>
    <option value="placeholder" disabled>
      Select State
    </option>
    <option value="TX">Texas</option>
  </Input>
);

InputState.propTypes = propTypes;
InputState.defaultProps = defaultProps;

export { InputState };



// WEBPACK FOOTER //
// ./src/business/register/components/input-state.js